
import React, { Component } from "react";

import {  Button as SVAButton } from 'antd';
import { Collapse } from 'antd';
import { Icon,Tag } from 'antd';
import { Steps, Divider } from 'antd';
import {
    browserHistory as history
  } from 'react-router'
import { IconMap } from "antd/lib/result";

const { Step } = Steps;




const {Link} = require("react-router")
const { Panel } = Collapse;
const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;

class AmbTravellersDetailView extends Component {
    constructor(props) {
        super(props)
        let me = this
      
        this.state = {
            expandIconPosition: 'left',
          }
        
      
        this.location = {
            "resort_name": "253 Mancreek Resort",
            "address_line1": " 253 scottland av",
            "county": "albanyt",
            "postalcode": 12193,
            "market_code": "NAMER",
            "country": "usa",
            "region_desc_en": [
                "United States",
                "Coastal Mid Atlantic"
            ],
            "state": "NY",
        }

       
    }
    
  
    componentWillMount()	{
        console.log('sv--task=--- link sends us params')
       
       console.log(this.props);
      
      
       
      console.log('sv-cook********2' )
     


    console.log('sbv--sjourn id ****+++++++++++++++++++++++++++ we will use _doc as the space has details of sohourn as single flat indxex:')
       
  

   
       // this.props.priceAndTexNow(id);
   
			
			
	

	}
   

    render() {
        /*
 let svr_fly = {
      "startdate": soj['startdate'] ? soj['startdate'] : "06:30",
                                        "enddate": soj['enddate'] ? soj['enddate'] : "7:30",
                                        "flight_arrival_daytime": soj['flight_arrival_daytime'] ? soj['flight_arrival_daytime'] : "AM",
                                        "flight_departure_daytime": soj['flight_departure_daytime'] ? soj['flight_departure_daytime'] : "PM",

                                        "origin_airport_code": soj['origin_airport_code'] ? soj['origin_airport_code'] : "SJC",
                                        "origincity": soj['origincity'] ? soj['origincity'] : "Sajn Jose",
                                        "dst_airport_code": soj['dst_airport_code'] ? soj['dst_airport_code'] : "AUS",
                                        "destcity": soj['destcity'] ? soj['destcity'] : "Austin",
                                        "airlines_name": soj['airlines_name'] ? soj['airlines_name'] : "Delta Airlines",
                                        

                                    }
        */
     const {svcustProfile} = this.props
     let travelerPricings = null
     if(this.props.travelerPricings){
        travelerPricings = this.props.travelerPricings
     }
     let rating_info = 'Excellennt, 4.0'
     let tp = null
     if(!travelerPricings){
         travelerPricings = [
            {
                "travelerId": "1",
                "fareOption": "STANDARD",
                "travelerType": "ADULT",
                "price": {
                    "currency": "USD",
                    "total": "1446.23",
                    "base": "1324.63"
                },
                "fareDetailsBySegment": [
                    {
                        "segmentId": "1",
                        "cabin": "BUSINESS",
                        "fareBasis": "KH0OASFN",
                        "brandedFare": "FR",
                        "brandedFareLabel": "FIRST",
                        "class": "C",
                        "includedCheckedBags": {
                            "quantity": 2
                        },
                        "amenities": [
                            {
                                "description": "SEAT ASSIGNMENT",
                                "isChargeable": false,
                                "amenityType": "PRE_RESERVED_SEAT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "MEAL 1",
                                "isChargeable": false,
                                "amenityType": "MEAL",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "PRIORITY BOARDING",
                                "isChargeable": false,
                                "amenityType": "TRAVEL_SERVICES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "110V AC POWER",
                                "isChargeable": false,
                                "amenityType": "ENTERTAINMENT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "USB POWER",
                                "isChargeable": false,
                                "amenityType": "ENTERTAINMENT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "CHANGEABLE TICKET",
                                "isChargeable": false,
                                "amenityType": "BRANDED_FARES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            }
                        ]
                    },
                    {
                        "segmentId": "2",
                        "cabin": "BUSINESS",
                        "fareBasis": "KH0OASFN",
                        "brandedFare": "FR",
                        "brandedFareLabel": "FIRST",
                        "class": "C",
                        "includedCheckedBags": {
                            "quantity": 2
                        },
                        "amenities": [
                            {
                                "description": "SEAT ASSIGNMENT",
                                "isChargeable": false,
                                "amenityType": "PRE_RESERVED_SEAT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "MEAL 1",
                                "isChargeable": false,
                                "amenityType": "MEAL",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "PRIORITY BOARDING",
                                "isChargeable": false,
                                "amenityType": "TRAVEL_SERVICES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "110V AC POWER",
                                "isChargeable": false,
                                "amenityType": "ENTERTAINMENT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "USB POWER",
                                "isChargeable": false,
                                "amenityType": "ENTERTAINMENT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "CHANGEABLE TICKET",
                                "isChargeable": false,
                                "amenityType": "BRANDED_FARES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            }
                        ]
                    },
                    {
                        "segmentId": "3",
                        "cabin": "BUSINESS",
                        "fareBasis": "KH0OASFN",
                        "brandedFare": "FR",
                        "brandedFareLabel": "FIRST",
                        "class": "C",
                        "includedCheckedBags": {
                            "quantity": 2
                        },
                        "amenities": [
                            {
                                "description": "SEAT ASSIGNMENT",
                                "isChargeable": false,
                                "amenityType": "PRE_RESERVED_SEAT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "MEAL 1",
                                "isChargeable": false,
                                "amenityType": "MEAL",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "PRIORITY BOARDING",
                                "isChargeable": false,
                                "amenityType": "TRAVEL_SERVICES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "110V AC POWER",
                                "isChargeable": false,
                                "amenityType": "ENTERTAINMENT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "USB POWER",
                                "isChargeable": false,
                                "amenityType": "ENTERTAINMENT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "CHANGEABLE TICKET",
                                "isChargeable": false,
                                "amenityType": "BRANDED_FARES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            }
                        ]
                    }
                ]
            }
        ]
        tp = travelerPricings[0]
        
     }else{
        tp = travelerPricings[0]
     }
     
     let {price, fareDetailsBySegment} = tp
     let fd = [
        {
            "segmentId": "1",
            "cabin": "ECONOMY",
            "fareBasis": "OH5OAVBN",
            "brandedFare": "SV",
            "brandedFareLabel": "SAVER",
            "class": "X",
            "includedCheckedBags": {
                "quantity": 0
            },
            "amenities": [
                {
                    "description": "STANDARD PIECE MAX 50LB 62LI",
                    "isChargeable": true,
                    "amenityType": "BAGGAGE",
                    "amenityProvider": {
                        "name": "BrandedFare"
                    }
                },
                {
                    "description": "MEAL 1",
                    "isChargeable": true,
                    "amenityType": "MEAL",
                    "amenityProvider": {
                        "name": "BrandedFare"
                    }
                },
                {
                    "description": "110V AC POWER",
                    "isChargeable": false,
                    "amenityType": "ENTERTAINMENT",
                    "amenityProvider": {
                        "name": "BrandedFare"
                    }
                },
                {
                    "description": "USB POWER",
                    "isChargeable": false,
                    "amenityType": "ENTERTAINMENT",
                    "amenityProvider": {
                        "name": "BrandedFare"
                    }
                }
            ]
        }]
     if(!fareDetailsBySegment){
         fd = [
            {
                "segmentId": "1",
                "cabin": "ECONOMY",
                "fareBasis": "OH5OAVBN",
                "brandedFare": "SV",
                "brandedFareLabel": "SAVER",
                "class": "X",
                "includedCheckedBags": {
                    "quantity": 0
                },
                "amenities": [
                    {
                        "description": "STANDARD PIECE MAX 50LB 62LI",
                        "isChargeable": true,
                        "amenityType": "BAGGAGE",
                        "amenityProvider": {
                            "name": "BrandedFare"
                        }
                    },
                    {
                        "description": "MEAL 1",
                        "isChargeable": true,
                        "amenityType": "MEAL",
                        "amenityProvider": {
                            "name": "BrandedFare"
                        }
                    },
                    {
                        "description": "110V AC POWER",
                        "isChargeable": false,
                        "amenityType": "ENTERTAINMENT",
                        "amenityProvider": {
                            "name": "BrandedFare"
                        }
                    },
                    {
                        "description": "USB POWER",
                        "isChargeable": false,
                        "amenityType": "ENTERTAINMENT",
                        "amenityProvider": {
                            "name": "BrandedFare"
                        }
                    }
                ]
            }]
     }else{
         fd = fareDetailsBySegment[0]
     }
     

     let cabinClass = fd["cabin"] ? fd["cabin"] :"Main Class"
     let tageGroup = fd["travelerType"] ? fd["travelerType"] :"ADULT"
     let tfareGroup = fd["brandedFareLabel"] ?fd["brandedFareLabel"] : "STANDARD"
     let tClass = fd["class"] ? fd["class"] :"X" 
     let {amenities} = fd
     if(!amenities){
         amenities = [
            {
                "description": "STANDARD PIECE MAX 50LB 62LI",
                "isChargeable": true,
                "amenityType": "BAGGAGE",
                "amenityProvider": {
                    "name": "BrandedFare"
                }
            },
            {
                "description": "110V AC POWER",
                "isChargeable": false,
                "amenityType": "ENTERTAINMENT",
                "amenityProvider": {
                    "name": "BrandedFare"
                }
            }
        ]
     }
     let iconMap = {
        "BAGGAGE":{"type":"contacts", "color" :"#e14a4a"},
        "MEAL":{"type":"audio", "color" :"#829d21"},
        "ENTERTAINMENT_USB":{"type":"bank", "color" :"#5a7ed2"},
        "ENTERTAINMENT_AC":{"type":"bulb", "color" :"#aa2f96"},
        "OTHERS2":{"type":"fund", "color" :"#122a96"},
     }
     let tckBags =  0
     let cur = (price.currency == 'USD') ? "$": price.currency

     if(fd.includedCheckedBags && fd.includedCheckedBags.quantity ){
         tckBags = fd.includedCheckedBags.quantity
     }
     let tsummary = tp.travelerId + ", " + tp.fareOption +  ", " + tp.travelerType
 
     






     
        
        return(  <div className="rev-row ">
            
            <div className="card card--raised with-shadow">
            
                
           
        <p className="sd-check"><text>Round Trip </text></p>
        <p className="sd-content"> <text>{cabinClass}</text></p>
        <p className="sd-check"> <text> {tsummary}
                       </text>
        </p>
        <p className="sd-rating"> <text style={{fontSize:'12px', fontWeight:'300'}}>{rating_info? rating_info:'Excellent, 9.1' }   </text></p>
        
        <p className="sd-numreview">  <span style={{fontSize: "14px"}} ><Tag color="magenta">5.0</Tag> <text ><span style={{paddingLeft: "10px"}}>Good,</span> <span> 13 Reviews </span></text></span></p>
        
        
         
        <div className="box-left-listhotels">
                                           
                                            <p className="m-para-text">
                                           
                                                <span style={{fontSize: "14px"}} > <Icon  style={{ color: '#122f96' }} type="audio" theme="filled" /><text style={{paddingLeft: "10px"}}>Included Checked Baggage :{tckBags}</text></span>
                                               
                                                
                                            </p>
                                            <p>
                                                <dl>
                                                    <dt className="tax-ib-info"><span className="nh"><text className="tax-line"> Total Per person </text></span></dt>
                                                    <dd className="tax-ib-amt"><span className="n2">{cur}{price.total?price.total:'49.26' } </span> </dd>
                                                </dl>

                                            </p>

                                            <p>
                                                <dl>
                                                    <dt className="tax-ib-info"><span className="nh"><text className="tax-line"> Base Per Person </text></span></dt>
                                                    <dd className="tax-ib-amt"><span className="n2">{cur}{price.base?price.base:'49.26' } </span> </dd>
                                                </dl>

                                            </p>

                                            <p className="m-para-text">
                                           
                                                  <span style={{fontSize: "14px"}} > <Icon  style={{ color: '#ebff96' }} type="bank" theme="filled" /><text style={{paddingLeft: "10px"}}>Changes Allowed</text></span>
                                                
                                                
                                            </p>
                                            <p className="m-para-text">
                                           
                                            <span style={{fontSize: "14px"}} > <Icon  style={{ color: '#ebff96' }} type="bank" theme="filled" /><text style={{paddingLeft: "10px"}}>Extra Leg Space</text></span>
                                           
                                           
                                       </p>
        </div>
        <div className="box-left-listhotels">
                                           
                                           
                                           
                                            {
                                                amenities.map( (o,idx) =>{
                                                    let txt = o.isChargeable? "Pay To" :'Free Inc'
                                                    let itype = iconMap['OTHERS2']
                                                    let ifound = iconMap['BANK']
                                                    let iamen = o.amenityType
                                                    let s = ''
                                                    if(o.amenityType == 'ENTERTAINMENT'){
                                                         s = o.description
                                                        itype = iconMap["OTHERS2"]
                                                        iamen = o.description
                                                        
                                                        
                                                        if(s.indexOf("AC") > 0){
                                                                itype = iconMap[o.amenityType+'_'+'AC']
                                                        }
                                                        if(s.indexOf("USB") > 0){
                                                            itype = iconMap[o.amenityType+'_'+'USB']
                                                        }
                                                    }else{
                                                         itype =  iconMap[o.amenityType] ? iconMap[o.amenityType] : ifound
                                                        
                                                    }
                                                   
                                                    return (
                                                        <p className="m-para-text">
                                                            {/* 
                                                             <span style={{fontSize: "14px"}} > <Icon  style={{ color: itype.color }} type={itype.type} theme="filled" /><text style={{paddingLeft: "10px"}}>{txt} {iamen}</text></span>
                                                   
                                                             */}
                                                    <span style={{fontSize: "14px"}} > <Icon  style={{ color: "#ff1234" }} type="audio" theme="filled" /><text style={{paddingLeft: "10px"}}>{txt} {iamen}</text></span>
                                                    </p>
                                                    )
                                                })
                                            }
                                                
                                                
                                           
                                            
        </div>
       

        </div>
        
    </div>
)
    }

 
}


export default AmbTravellersDetailView